import { useEffect, useRef } from "react";
import notificationSound from '../../assets/sound/callRingtone.mp3'
import { doc, updateDoc } from "firebase/firestore";
import { firestore as db } from "../../firebase/firebase";
export const CallPopup = ({
  callNotification,
  setCallNotification,
  setIsCallModalOpen,
}: {
  callNotification: {
    status: boolean;
    message: string;
    doctorImage?: string;
    appointmentId: string;
    patientId: string;
  };
  setCallNotification: (notification: {
    status: boolean;
    message: string;
    doctorImage?: string;
    appointmentId: string;
    patientId: string;

  }) => void;
  setIsCallModalOpen: (isCallModalOpen: boolean) => void;
}) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  // Initialize the audio when the component mounts
  useEffect(() => {
    // Create audio element if it doesn't exist
    if (!audioRef.current) {
      audioRef.current = new Audio(notificationSound); // Path to your ring sound
      audioRef.current.loop = true; // Enable looping
    }

    // Play or pause based on call notification status
    if (callNotification.status) {
      audioRef.current.play().catch(error => {
        console.error('Error playing audio:', error);
      });
    } else {
      audioRef.current.pause();
      audioRef.current.currentTime = 0; // Reset audio to beginning
    }

    // Clean up function to stop audio when component unmounts
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = '';
        audioRef.current = null;
      }
    };
  }, [callNotification.status]);

  if (!callNotification.status) return null;

  const handlePickupCall = async () => {
    // Stop the ringing sound
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }

    setCallNotification({
      status: false,
      message: "",
      appointmentId: '',
      patientId: '',
    });
    await updateDoc(doc(db, 'patientAvailability', callNotification.appointmentId), {
      roomStatus: 'ONGOING',
    });
    setIsCallModalOpen(true);
  };

  const handleDeclineCall = () => {
    // Stop the ringing sound
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }

    setCallNotification({
      status: false,
      message: '',
      appointmentId: '',
      patientId: '',
    });
  };

  return (

    <div className="fixed h-full top-0 right-0  bg-black/40  w-full z-50 p-7 flex items-start justify-end ">
      <div className="flex flex-col items-center bg-white rounded-lg shadow-2xl p-4 max-w-[420px]">
        {/* Doctor profile picture */}
        <div className="mb-3">
          <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-gray-200">
            {callNotification.doctorImage ? (
              <img
                src={callNotification.doctorImage}
                alt="Doctor"
                className="w-full h-full object-cover"
              />
            ) : (
              // Fallback profile icon if no image is provided
              <div className="w-full h-full bg-gray-200 flex items-center justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
            )}
          </div>
        </div>

        <div className="text-xl font-semibold mb-4 text-center">
          {callNotification.message}
        </div>

        {/* Call actions */}
        <div className="flex items-center space-x-6">
          {/* Decline button - red */}
          <button
            onClick={handleDeclineCall}
            className="bg-red-500 hover:bg-red-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-colors duration-300"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          {/* Answer button - green */}
          <button
            onClick={handlePickupCall}
            className="bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg transition-colors duration-300"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};
